import React, { useEffect, useRef, useState } from 'react';
import './user-filter-modal.styles.scss';
import Modal from '@/components/SHARED/modal/modal.component';
import { states } from '@/pages/profile/states';

const UserFilterModal = ({
    show,
    cancel,
    filter,
    setFilter
}) => {

    const [ tempFilter, setTempFilter ] = useState({});

    useEffect(() => {
        if (!filter) return;
        setTempFilter({...filter});
    }, [filter])

    function chooseFilter(key, value) {
        let tempFil = {...tempFilter};
        let condition;
        if (key === 'state') {
            condition = 'equals'
        } else if (key.includes('ts')) {
            condition = 'greaterThan'
        }
        tempFil[key] = {
            'key': key,
            'value': value,
            'condition': condition
        }
        setTempFilter({...tempFil});
    }

    function finalizeFilter() {
        setFilter({...tempFilter});
        cancel();
    }

    function clearFilter() {
        setTempFilter({});
        setFilter({});
        cancel();
    }

    return (
        <div className='user-filter-modal'>
            <Modal
                show={show}
                cancel={cancel}
                closeButton={true}
                text="Set User List Filters" 
                cls="narrow" >
                <div className='filter-content'>
                    {
                        (tempFilter) &&
                        <div className='field small'>
                            <label>
                                State
                            </label>
                            <select
                                value={tempFilter.state ? tempFilter.state.value : ''}
                                onChange={(e) => chooseFilter('state', e.target.value)} >
                                <option value="">Choose a State</option>
                                {
                                    (states) &&
                                    states.map(s => (
                                        <option
                                            key={s.name}
                                            value={s.abbreviation}>
                                            {s.name}
                                        </option>
                                    ))
                                }
                            </select>
                        </div>
                    }
                    <div className="g-space-1"></div>
                    <div className='buttons with-left-button'>
                        <div>
                            <button 
                                className='g-button small-btn'
                                onClick={() => clearFilter()}>
                                Clear Filter
                            </button>
                        </div>  
                        <button 
                            className='g-button'
                            onClick={() => cancel()}>
                            Cancel
                        </button>
                        <button 
                            className='g-button primary'
                            onClick={() => finalizeFilter()} >
                            Set Filter
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default UserFilterModal